<mat-icon fontSet="mdi" fontIcon="mdi-information-outline"></mat-icon>
<span class="text-content"><ng-content></ng-content></span>
